<app-basic-page title="Kassen schließen">
  @if (!selectedLocationCashPointLinker) {
    <div class="absolute inset-0 overflow-y-auto pr-2">
      <ul *ngIf="locationCashPointLinker" role="list"
          class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 xl:gap-x-8">
        <li *ngFor="let linker of locationCashPointLinker"
            cdkDropList [cdkDropListConnectedTo]="drops" [cdkDropListData]="linker.cpes"
            (cdkDropListDropped)="drop($event)" [id]="linker.location.id"
            class="overflow-hidden rounded-xl border border-gray-200 self-start"
            [ngClass]="{'opacity-50': linker.cpes.length == 0}">
          <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-2">
            <div class="h-12 w-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10 p-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <g class="fill-none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                   stroke-width="2">
                  <path
                    d="M21 15h-2.5a1.503 1.503 0 0 0-1.5 1.5a1.503 1.503 0 0 0 1.5 1.5h1a1.503 1.503 0 0 1 1.5 1.5a1.503 1.503 0 0 1-1.5 1.5H17m2 0v1m0-8v1m-6 6H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2m12 3.12V9a2 2 0 0 0-2-2h-2"/>
                  <path
                    d="M16 10V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6m8 0H8m8 0h1m-9 0H7m1 4v.01M8 17v.01m4-3.02V14m0 3v.01"/>
                </g>
              </svg>
            </div>
            <div class="flex flex-col">
              <div class="font-medium leading-6 text-gray-900">{{ linker.location.name }}</div>
              <span *ngIf="linker.cpes.length > 0" class="text-sm text-gray-500">Kassen: {{ linker.cpes.length }}</span>
            </div>
            @if (linker.cpes.length > 0) {
              <div class="ml-auto">
                <a (click)="select(linker)" class="text-theme-primary-700 hover:text-theme-primary-900">schließen</a>
              </div>
            }
          </div>
          <div class="-my-3 divide-y divide-gray-100 py-4 text-sm leading-6 flex flex-col">
            @for (cpe of linker.cpes; track cpe) {
              <div class="flex w-full h-full py-2 px-4 text-sm bg-white !cursor-grab" cdkDrag>
                <div class="bg-gray-200 h-12 w-full" *cdkDragPlaceholder></div>
                <div *cdkDragPreview class="bg-white border-[1px] border-gray-200 h-12 rounded-xl p-2 flex">
                  <span class="m-auto">{{ cpe.device.name }}</span>
                </div>
                <span>{{ cpe.device.name }}</span>
              </div>
            }
          </div>
        </li>
      </ul>
    </div>
  } @else if (selectedLocationCashPointLinker) {
    <div class="absolute inset-0 pr-2 flex flex-col">
      <div class="rounded-xl border border-gray-200 flex flex-col bg-gray-50">
        <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-2 rounded-xl">
          <div class="h-12 w-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10 p-2">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
              <path
                d="M9.5 7a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0M14 7c0 2.874-3.097 6.016-4.841 7.558a1.74 1.74 0 0 1-2.318 0C5.097 13.016 2 9.874 2 7a6 6 0 1 1 12 0m-1 0A5 5 0 0 0 3 7c0 1.108.615 2.395 1.57 3.683c.934 1.258 2.087 2.377 2.933 3.126a.74.74 0 0 0 .994 0c.846-.749 2-1.867 2.933-3.126C12.385 9.395 13 8.108 13 7"/>
            </svg>
          </div>
          <div class="flex flex-col">
            <div class="font-medium leading-6 text-gray-900">{{ selectedLocationCashPointLinker.location.name }}</div>
            <span *ngIf="selectedLocationCashPointLinker.cpes.length > 0"
                  class="text-sm text-gray-500">Kassen: {{ selectedLocationCashPointLinker.cpes.length }}</span>
          </div>
          <div class="ml-auto">
            <a (click)="select(undefined)" class="text-theme-primary-700 hover:text-theme-primary-900">zurück</a>
          </div>
        </div>
        <div
          *ngIf="cashModel.remaining == 0 && selectedLocationCashPointLinker.cpes.length > 0 && cashModel.hasUnfinished"
          class="bg-gray-50 mx-auto p-2">
          <a class="text-green-700 hover:text-green-900 font-bold text-xl" (click)="close()">
            {{ selectedLocationCashPointLinker.cpes.length > 1 ? selectedLocationCashPointLinker.cpes.length : "" }}
            Kasse{{ selectedLocationCashPointLinker.cpes.length > 1 ? "n" : "" }} schließen</a>
        </div>
      </div>
      <div class="overflow-y-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 pt-4 gap-3">
          <div *ngIf="cashModel.hasUnfinished" class="overflow-hidden rounded-xl border border-gray-200 self-start">
            <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-2">
            <span class="h-12 w-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10 p-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g><path
                fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8a4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0a5 5 0 0 1 10 0"/><path
                d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207c0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158c0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522c0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569c0 .339-.257.571-.709.614v-1.195z"/><path
                d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"/><path
                d="M9.998 5.083L10 5a2 2 0 1 0-3.132 1.65a6 6 0 0 1 3.13-1.567"/></g></svg>
            </span>
              <div class="text-sm font-medium leading-6 text-gray-900">Gezähltes Bargeld</div>
            </div>
            <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
              <div>
                <div class="flex justify-between gap-x-4 pt-3">
                  <dt class="text-gray-500 place-self-center">Münzen</dt>
                  <dd class="text-gray-600 place-self-center">
                    <app-currency-input #coin_input [(input)]="cashModel.coins" [negative]="false"></app-currency-input>
                  </dd>
                </div>
                <div class="flex justify-between gap-x-4 py-2">
                  <dt class="text-gray-500 place-self-center">Rollen</dt>
                  <dd class="text-gray-600 place-self-center">
                    <app-currency-input #roll_input [(input)]="cashModel.rolls" [negative]="false"></app-currency-input>
                  </dd>
                </div>
                <div class="flex justify-between gap-x-4 pb-3">
                  <dt class="text-gray-500 place-self-center">Scheine</dt>
                  <dd class="text-gray-600 place-self-center">
                    <app-currency-input #bill_input [(input)]="cashModel.bills" [negative]="false"></app-currency-input>
                  </dd>
                </div>
              </div>
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 place-self-center">Gesamt</dt>
                <dd class="text-black place-self-center">
                  <span>{{ (cashModel.total ?? 0) | currency: "EUR" }}</span>
                </dd>
              </div>
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 place-self-center">Verbleibend</dt>
                <dd class="text-black place-self-center"
                    [ngClass]="{'!text-green-700': cashModel.remaining > 0, '!text-red-700': cashModel.remaining < 0}">
                  <span>{{ cashModel.remaining | currency: "EUR" }}</span>
                </dd>
              </div>
            </dl>
          </div>
          <div *ngFor="let cpe of selectedLocationCashPointLinker.cpes"
               class="overflow-hidden rounded-xl border border-gray-200 flex flex-col relative">
            <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-2">
              <span class="h-12 w-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10 p-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <g class="fill-none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                     stroke-width="2">
                    <path
                      d="M21 15h-2.5a1.503 1.503 0 0 0-1.5 1.5a1.503 1.503 0 0 0 1.5 1.5h1a1.503 1.503 0 0 1 1.5 1.5a1.503 1.503 0 0 1-1.5 1.5H17m2 0v1m0-8v1m-6 6H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2m12 3.12V9a2 2 0 0 0-2-2h-2"/>
                    <path
                      d="M16 10V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6m8 0H8m8 0h1m-9 0H7m1 4v.01M8 17v.01m4-3.02V14m0 3v.01"/>
                  </g>
                </svg>
              </span>
              <div class="text-sm font-medium leading-6 text-gray-900">{{ cpe.device.name }}</div>
            </div>
            <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
              <div class="py-3 space-y-0.5">
                <div class="flex justify-between gap-x-4"
                     *ngFor="let type of getBusinessCaseTypes(cpe.closing.businessCaseTypes)">
                  <dt class="text-gray-500 place-self-center">{{ BusinessCaseTypeLabels[type] }}</dt>
                  <dd class="text-gray-600 place-self-center">
                    <span>{{ cpe.closing.businessCaseTypes[type] | currency: "EUR" }}</span>
                  </dd>
                </div>
              </div>
              <div class="py-3 space-y-0.5">
                <div class="flex justify-between gap-x-4" *ngFor="let type of getBookingTypes(cpe.closing.summary)">
                  <dt class="text-gray-500 place-self-center">{{ BookingTypeLabels[type] }}</dt>
                  <dd class="text-gray-600 place-self-center">
                    <span>{{ cpe.closing.summary[type] | currency: "EUR" }}</span>
                  </dd>
                </div>
              </div>
            </dl>
            <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6 mt-auto">
              <span class="fw-bold text-lg">Kassenbestand</span>
              <div class="py-3 space-y-3">
                <div class="flex justify-between gap-x-4">
                  <dt class="text-gray-500 place-self-center">Soll</dt>
                  <dd class="text-black place-self-center">
                    <span>{{ cpe.closing.get(BookingType.Cash) | currency: "EUR" }}</span>
                  </dd>
                </div>
                <div class="flex justify-between gap-x-4">
                  <dt class="text-gray-500 place-self-center">Ist</dt>
                  <dd class="text-black place-self-center">
                    <app-currency-input [(input)]="cpe.closing.actual" [negative]="false"
                                        [placeholder]="(cpe.closing.get(BookingType.Cash) | number: '1.2-2')!"/>
                  </dd>
                </div>
                <div class="flex justify-between gap-x-4">
                  <dt class="text-gray-500 place-self-center">
                    <span>Differenz</span>
                    <a *ngIf="cashModel.remaining != 0" (click)="cpe.closing.add(cashModel.remaining)"
                       class="text-theme-primary-700 hover:text-theme-primary-900 font-light pl-2">übernehmen</a>
                  </dt>
                  <dd class="text-black place-self-center">
                    <app-currency-input [readonly]="true" [colored]="true" [negative]="true"
                                        [input]="(cpe.closing.actual ?? cpe.closing.get(BookingType.Cash)) - cpe.closing.get(BookingType.Cash)"/>
                  </dd>
                </div>
                <div class="flex justify-between gap-x-4 -ml-2 -mr-1">
                <textarea class="w-full border-2 rounded-md px-1 resize-none" [(ngModel)]="cpe.closing.comment"
                          placeholder="Kommentar" rows="4"></textarea>
                </div>
              </div>
            </dl>
            <dl class="-my-3 divide-y divide-gray-100 px-6 py-2 text-sm leading-6">
              <span class="fw-bold text-lg">Geldtransit</span>
              <span class="block text-xs text-gray-500 pb-1" data-testid="geldtransit-hint">Positiver Betrag: Abschöpfung (Bargeld verlässt die Kasse). Negativer Betrag oder Endbestand über dem Ist: Einlage.</span>
              <div class="py-3 space-y-3">
                <div class="flex justify-between gap-x-4">
                  <dt class="text-gray-500 place-self-center">Betrag</dt>
                  <dd class="text-black place-self-center">
                    <app-currency-input [negative]="true" [(input)]="cpe.closing.skimming_difference"
                                        [readonly]="cpe.closing.skimming_result != null"
                                        [placeholder]="((cpe.closing.actual ?? cpe.closing.get(BookingType.Cash)) - (cpe.closing.skimming_result ?? (cpe.closing.actual ?? cpe.closing.get(BookingType.Cash)) - (cpe.closing.skimming_difference ?? 0)) | number: '1.2-2')!"/>
                  </dd>
                </div>
                <div class="flex justify-between gap-x-4">
                  <dt class="text-gray-500 place-self-center">Endbestand</dt>
                  <dd class="text-black place-self-center">
                    <app-currency-input [negative]="false" [(input)]="cpe.closing.skimming_result"
                                        [readonly]="cpe.closing.skimming_difference != null"
                                        [placeholder]="((cpe.closing.actual ?? cpe.closing.get(BookingType.Cash)) - (cpe.closing.skimming_difference ?? 0) | number: '1.2-2')!"/>
                  </dd>
                </div>
              </div>
            </dl>
            <div class="absolute inset-0 bg-white" *ngIf="cpe.closing.success">
              <div class="absolute flex flex-col left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2">
                <span class="text-green-700 text-center mx-auto">
                  <svg height="64" width="64" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g
                    class="fill-none"
                    fill-rule="evenodd"><path
                    d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path

                    d="M21.546 5.111a1.5 1.5 0 0 1 0 2.121L10.303 18.475a1.6 1.6 0 0 1-2.263 0L2.454 12.89a1.5 1.5 0 1 1 2.121-2.121l4.596 4.596L19.424 5.111a1.5 1.5 0 0 1 2.122 0"/></g></svg>
                </span>
                <span class="text-center mx-auto">{{ cpe.device.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

</app-basic-page>
